import 'react-app-polyfill/ie9'
import 'react-app-polyfill/stable'
import { ConnectedRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import App from './App'
import './site.scss'
import configureStore from './store/_configureStore.ts'
import { RootState } from './store/RootState.ts'
import { ThemeProvider } from './ThemeProvider'


// Create browser history to use in the Redux store
const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href')
const history = createBrowserHistory({ basename: baseUrl })

// Get the application-wide store instance, prepopulating with state from the server where available.

const initialState = {
    auth: JSON.parse(localStorage.getItem('auth'))
}

const store = configureStore(history, initialState)
const rootElement = document.getElementById('root')


ReactDOM.render(
    <Provider store={store}>
        <ThemeProvider>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>       
        </ThemeProvider>
    </Provider>,
    rootElement
)

